var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.719 9A8.719 8.719 0 11.28 9a8.719 8.719 0 0117.438 0zm-9.727 4.617l6.468-6.47a.563.563 0 000-.795l-.795-.795a.562.562 0 00-.796 0l-5.275 5.275L5.13 8.37a.563.563 0 00-.796 0l-.795.796a.563.563 0 000 .795l3.656 3.656c.22.22.576.22.796 0z",
    fill: "#6ABAA4"
  })));
}

export default __webpack_public_path__ + "./fonts/check-circle-green.548146340604a886d0dfc29cd4019e8c.svg";
export { SvgCheckCircleGreen as ReactComponent };